import { Image } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { Body } from "capitalrx-components-2.0/lib/typography";

import CapRxLogo from "@/static/images/caprx-logo.svg?url";

import styles from "./WhiteLabelFooter.module.scss";

export const Footer = () => {
  return (
    <Shelf alignment="center" className={styles.WhiteLabelFooter}>
      <div role="img" aria-label="client logo" className={styles["LogoImage"]} />
      <Body size="small" className={styles.WhiteLabelFooterText}>Powered by <Image src={CapRxLogo} alt="Capital Rx Logo" /></Body>
    </Shelf>
  );
};
